export const CreditCardMastercardLogoIcon = ({
  width = 56,
  height = 37,
  title = "Mastercard Payment",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 57 38"
      role="img"
      aria-label="Mastercard"
      {...rest}>
      <title>{title}</title>
      <path fill="#FF5F00" d="M35.7 6.5H20.8v24.4h14.9z"></path>
      <path
        fill="#EB001B"
        d="M22.4 18.7c0-4.8 2.2-9.3 5.9-12.2-6.7-5.3-16.5-4.1-21.8 2.6S2.4 25.6 9.1 30.9c5.6 4.4 13.5 4.4 19.2 0-3.7-2.9-5.9-7.4-5.9-12.2"></path>
      <path
        fill="#F79E1B"
        d="M51.9 28.3v-.5h.2v-.1h-.5v.1h.2zm1 0v-.6h-.2l-.2.4-.2-.4h-.2v.6h.1v-.5l.2.4h.1l.2-.4v.5zM53.4 18.7c0 8.6-6.9 15.5-15.5 15.5-3.5 0-6.9-1.2-9.6-3.3 6.7-5.3 7.9-15 2.6-21.8-.8-1-1.6-1.8-2.6-2.6C35 1.2 44.8 2.4 50.1 9.1c2.1 2.7 3.3 6.1 3.3 9.6"></path>
    </svg>
  );
};
